/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CustomerRouteRouteImport } from './routes/customer/route'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as InternalRouteRouteImport } from './routes/internal/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PublicRouteRouteImport } from './routes/public/route'
import { Route as CustomerAccountRouteImport } from './routes/customer/account'
import { Route as CustomerDashboardRouteImport } from './routes/customer/dashboard'
import { Route as CustomerMatchesRouteImport } from './routes/customer/matches'
import { Route as InternalAccountRouteImport } from './routes/internal/account'
import { Route as InternalCatalogueRouteImport } from './routes/internal/catalogue'
import { Route as InternalDashboardRouteImport } from './routes/internal/dashboard'
import { Route as InternalMatchingRouteImport } from './routes/internal/matching'
import { Route as InternalMediaRouteImport } from './routes/internal/media'
import { Route as InternalPropertiesRouteImport } from './routes/internal/properties'
import { Route as InternalSystemRouteRouteImport } from './routes/internal/system/route'
import { Route as McpConsentRouteImport } from './routes/mcp.consent'
import { Route as PasswordResetTokenRouteImport } from './routes/password-reset.$token'
import { Route as StyleguideIndexRouteImport } from './routes/styleguide/index'
import { Route as StyleguideCustomerRouteImport } from './routes/styleguide/customer'
import { Route as StyleguideInternalRouteImport } from './routes/styleguide/internal'
import { Route as UploadTokenRouteImport } from './routes/upload.$token'
import { Route as CustomerProjectIndexRouteImport } from './routes/customer/project/index'
import { Route as CustomerProjectProjectIdRouteRouteImport } from './routes/customer/project/$projectId/route'
import { Route as InternalCustomerViewUserIdRouteRouteImport } from './routes/internal/customer-view/$userId/route'
import { Route as InternalProjectsIndexRouteImport } from './routes/internal/projects/index'
import { Route as InternalProjectsIdRouteRouteImport } from './routes/internal/projects/$id/route'
import { Route as InternalSystemIndexRouteImport } from './routes/internal/system/index'
import { Route as InternalSystemConfiguratorRouteImport } from './routes/internal/system/configurator'
import { Route as InternalSystemSettingsRouteRouteImport } from './routes/internal/system/settings/route'
import { Route as PublicConfiguratorIndexRouteImport } from './routes/public/configurator/index'
import { Route as PublicConfiguratorSummaryRouteImport } from './routes/public/configurator/summary'
import { Route as PublicProjectsPreviewIndexRouteImport } from './routes/public/projects-preview/index'
import { Route as PublicProjectsIndexRouteImport } from './routes/public/projects/index'
import { Route as PublicProjectsIdRouteImport } from './routes/public/projects/$id'
import { Route as PublicUnsubscribeTokenRouteImport } from './routes/public/unsubscribe.$token'
import { Route as CustomerProjectProjectIdIndexRouteImport } from './routes/customer/project/$projectId/index'
import { Route as CustomerProjectProjectIdConfigureRouteImport } from './routes/customer/project/$projectId/configure'
import { Route as CustomerProjectProjectIdSummaryRouteImport } from './routes/customer/project/$projectId/summary'
import { Route as InternalCustomerViewUserIdIndexRouteImport } from './routes/internal/customer-view/$userId/index'
import { Route as InternalCustomerViewUserIdDashboardRouteImport } from './routes/internal/customer-view/$userId/dashboard'
import { Route as InternalCustomerViewUserIdMatchesRouteImport } from './routes/internal/customer-view/$userId/matches'
import { Route as InternalProjectsIdIndexRouteImport } from './routes/internal/projects/$id/index'
import { Route as InternalProjectsIdDocumentsRouteImport } from './routes/internal/projects/$id/documents'
import { Route as InternalProjectsIdFinanceRouteImport } from './routes/internal/projects/$id/finance'
import { Route as InternalProjectsIdOverviewRouteImport } from './routes/internal/projects/$id/overview'
import { Route as InternalProjectsIdPlanningRouteImport } from './routes/internal/projects/$id/planning'
import { Route as InternalSystemAdministrationIndexRouteImport } from './routes/internal/system/administration/index'
import { Route as InternalSystemAdministrationBankRouteImport } from './routes/internal/system/administration/bank'
import { Route as InternalSystemAdministrationClassificationsRouteRouteImport } from './routes/internal/system/administration/classifications/route'
import { Route as InternalSystemAdministrationElementTypesRouteImport } from './routes/internal/system/administration/element-types'
import { Route as InternalSystemAdministrationMcpRouteImport } from './routes/internal/system/administration/mcp'
import { Route as InternalSystemAdministrationPartiesRouteImport } from './routes/internal/system/administration/parties'
import { Route as InternalSystemAdministrationPaymentPlansRouteImport } from './routes/internal/system/administration/payment-plans'
import { Route as InternalSystemAdministrationProductPropertiesRouteImport } from './routes/internal/system/administration/product-properties'
import { Route as InternalSystemAdministrationUsersRouteImport } from './routes/internal/system/administration/users'
import { Route as InternalSystemDevelopmentIndexRouteImport } from './routes/internal/system/development/index'
import { Route as InternalSystemDevelopmentSyncRouteImport } from './routes/internal/system/development/sync'
import { Route as InternalSystemOperationsIndexRouteImport } from './routes/internal/system/operations/index'
import { Route as InternalSystemOperationsBackupRouteImport } from './routes/internal/system/operations/backup'
import { Route as InternalSystemOperationsEmailRouteRouteImport } from './routes/internal/system/operations/email/route'
import { Route as InternalSystemOperationsHistoryRouteImport } from './routes/internal/system/operations/history'
import { Route as InternalSystemOperationsHousekeepingRouteImport } from './routes/internal/system/operations/housekeeping'
import { Route as InternalSystemOperationsLogsRouteImport } from './routes/internal/system/operations/logs'
import { Route as InternalSystemOperationsPermissionsRouteImport } from './routes/internal/system/operations/permissions'
import { Route as InternalSystemOperationsQueueRouteImport } from './routes/internal/system/operations/queue'
import { Route as InternalSystemOperationsSuggestionsRouteImport } from './routes/internal/system/operations/suggestions'
import { Route as InternalSystemSettingsIndexRouteImport } from './routes/internal/system/settings/index'
import { Route as InternalSystemSettingsAdvisorRouteImport } from './routes/internal/system/settings/advisor'
import { Route as InternalSystemSettingsAiRouteImport } from './routes/internal/system/settings/ai'
import { Route as InternalSystemSettingsCleanupRouteImport } from './routes/internal/system/settings/cleanup'
import { Route as InternalSystemSettingsEmailRouteImport } from './routes/internal/system/settings/email'
import { Route as InternalSystemSettingsHubspotRouteImport } from './routes/internal/system/settings/hubspot'
import { Route as InternalSystemSettingsImagesRouteImport } from './routes/internal/system/settings/images'
import { Route as InternalCustomerViewUserIdProjectIndexRouteImport } from './routes/internal/customer-view/$userId/project/index'
import { Route as InternalCustomerViewUserIdProjectProjectIdRouteRouteImport } from './routes/internal/customer-view/$userId/project/$projectId/route'
import { Route as InternalSystemAdministrationClassificationsIndexRouteImport } from './routes/internal/system/administration/classifications/index'
import { Route as InternalSystemAdministrationClassificationsCategoriesRouteImport } from './routes/internal/system/administration/classifications/categories'
import { Route as InternalSystemAdministrationClassificationsDesignLinesRouteImport } from './routes/internal/system/administration/classifications/design-lines'
import { Route as InternalSystemAdministrationClassificationsGroupsRouteImport } from './routes/internal/system/administration/classifications/groups'
import { Route as InternalSystemAdministrationClassificationsStandardsRouteImport } from './routes/internal/system/administration/classifications/standards'
import { Route as InternalSystemOperationsEmailIndexRouteImport } from './routes/internal/system/operations/email/index'
import { Route as InternalSystemOperationsEmailSubscriptionsRouteImport } from './routes/internal/system/operations/email/subscriptions'
import { Route as InternalCustomerViewUserIdProjectProjectIdIndexRouteImport } from './routes/internal/customer-view/$userId/project/$projectId/index'
import { Route as InternalCustomerViewUserIdProjectProjectIdConfigureRouteImport } from './routes/internal/customer-view/$userId/project/$projectId/configure'
import { Route as InternalCustomerViewUserIdProjectProjectIdSummaryRouteImport } from './routes/internal/customer-view/$userId/project/$projectId/summary'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerRouteRoute = CustomerRouteRouteImport.update({
  id: '/customer',
  path: '/customer',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const InternalRouteRoute = InternalRouteRouteImport.update({
  id: '/internal',
  path: '/internal',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/public',
  path: '/public',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerAccountRoute = CustomerAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => CustomerRouteRoute,
} as any)
const CustomerDashboardRoute = CustomerDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => CustomerRouteRoute,
} as any)
const CustomerMatchesRoute = CustomerMatchesRouteImport.update({
  id: '/matches',
  path: '/matches',
  getParentRoute: () => CustomerRouteRoute,
} as any)
const InternalAccountRoute = InternalAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => InternalRouteRoute,
} as any)
const InternalCatalogueRoute = InternalCatalogueRouteImport.update({
  id: '/catalogue',
  path: '/catalogue',
  getParentRoute: () => InternalRouteRoute,
} as any)
const InternalDashboardRoute = InternalDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => InternalRouteRoute,
} as any)
const InternalMatchingRoute = InternalMatchingRouteImport.update({
  id: '/matching',
  path: '/matching',
  getParentRoute: () => InternalRouteRoute,
} as any)
const InternalMediaRoute = InternalMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => InternalRouteRoute,
} as any)
const InternalPropertiesRoute = InternalPropertiesRouteImport.update({
  id: '/properties',
  path: '/properties',
  getParentRoute: () => InternalRouteRoute,
} as any)
const InternalSystemRouteRoute = InternalSystemRouteRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => InternalRouteRoute,
} as any)
const McpConsentRoute = McpConsentRouteImport.update({
  id: '/mcp/consent',
  path: '/mcp/consent',
  getParentRoute: () => rootRouteImport,
} as any)
const PasswordResetTokenRoute = PasswordResetTokenRouteImport.update({
  id: '/password-reset/$token',
  path: '/password-reset/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const StyleguideIndexRoute = StyleguideIndexRouteImport.update({
  id: '/styleguide/',
  path: '/styleguide/',
  getParentRoute: () => rootRouteImport,
} as any)
const StyleguideCustomerRoute = StyleguideCustomerRouteImport.update({
  id: '/styleguide/customer',
  path: '/styleguide/customer',
  getParentRoute: () => rootRouteImport,
} as any)
const StyleguideInternalRoute = StyleguideInternalRouteImport.update({
  id: '/styleguide/internal',
  path: '/styleguide/internal',
  getParentRoute: () => rootRouteImport,
} as any)
const UploadTokenRoute = UploadTokenRouteImport.update({
  id: '/upload/$token',
  path: '/upload/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerProjectIndexRoute = CustomerProjectIndexRouteImport.update({
  id: '/project/',
  path: '/project/',
  getParentRoute: () => CustomerRouteRoute,
} as any)
const CustomerProjectProjectIdRouteRoute =
  CustomerProjectProjectIdRouteRouteImport.update({
    id: '/project/$projectId',
    path: '/project/$projectId',
    getParentRoute: () => CustomerRouteRoute,
  } as any)
const InternalCustomerViewUserIdRouteRoute =
  InternalCustomerViewUserIdRouteRouteImport.update({
    id: '/customer-view/$userId',
    path: '/customer-view/$userId',
    getParentRoute: () => InternalRouteRoute,
  } as any)
const InternalProjectsIndexRoute = InternalProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => InternalRouteRoute,
} as any)
const InternalProjectsIdRouteRoute = InternalProjectsIdRouteRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => InternalRouteRoute,
} as any)
const InternalSystemIndexRoute = InternalSystemIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InternalSystemRouteRoute,
} as any)
const InternalSystemConfiguratorRoute =
  InternalSystemConfiguratorRouteImport.update({
    id: '/configurator',
    path: '/configurator',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemSettingsRouteRoute =
  InternalSystemSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const PublicConfiguratorIndexRoute = PublicConfiguratorIndexRouteImport.update({
  id: '/configurator/',
  path: '/configurator/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicConfiguratorSummaryRoute =
  PublicConfiguratorSummaryRouteImport.update({
    id: '/configurator/summary',
    path: '/configurator/summary',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const PublicProjectsPreviewIndexRoute =
  PublicProjectsPreviewIndexRouteImport.update({
    id: '/projects-preview/',
    path: '/projects-preview/',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const PublicProjectsIndexRoute = PublicProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicProjectsIdRoute = PublicProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicUnsubscribeTokenRoute = PublicUnsubscribeTokenRouteImport.update({
  id: '/unsubscribe/$token',
  path: '/unsubscribe/$token',
  getParentRoute: () => PublicRouteRoute,
} as any)
const CustomerProjectProjectIdIndexRoute =
  CustomerProjectProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CustomerProjectProjectIdRouteRoute,
  } as any)
const CustomerProjectProjectIdConfigureRoute =
  CustomerProjectProjectIdConfigureRouteImport.update({
    id: '/configure',
    path: '/configure',
    getParentRoute: () => CustomerProjectProjectIdRouteRoute,
  } as any)
const CustomerProjectProjectIdSummaryRoute =
  CustomerProjectProjectIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => CustomerProjectProjectIdRouteRoute,
  } as any)
const InternalCustomerViewUserIdIndexRoute =
  InternalCustomerViewUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InternalCustomerViewUserIdRouteRoute,
  } as any)
const InternalCustomerViewUserIdDashboardRoute =
  InternalCustomerViewUserIdDashboardRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => InternalCustomerViewUserIdRouteRoute,
  } as any)
const InternalCustomerViewUserIdMatchesRoute =
  InternalCustomerViewUserIdMatchesRouteImport.update({
    id: '/matches',
    path: '/matches',
    getParentRoute: () => InternalCustomerViewUserIdRouteRoute,
  } as any)
const InternalProjectsIdIndexRoute = InternalProjectsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InternalProjectsIdRouteRoute,
} as any)
const InternalProjectsIdDocumentsRoute =
  InternalProjectsIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => InternalProjectsIdRouteRoute,
  } as any)
const InternalProjectsIdFinanceRoute =
  InternalProjectsIdFinanceRouteImport.update({
    id: '/finance',
    path: '/finance',
    getParentRoute: () => InternalProjectsIdRouteRoute,
  } as any)
const InternalProjectsIdOverviewRoute =
  InternalProjectsIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => InternalProjectsIdRouteRoute,
  } as any)
const InternalProjectsIdPlanningRoute =
  InternalProjectsIdPlanningRouteImport.update({
    id: '/planning',
    path: '/planning',
    getParentRoute: () => InternalProjectsIdRouteRoute,
  } as any)
const InternalSystemAdministrationIndexRoute =
  InternalSystemAdministrationIndexRouteImport.update({
    id: '/administration/',
    path: '/administration/',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemAdministrationBankRoute =
  InternalSystemAdministrationBankRouteImport.update({
    id: '/administration/bank',
    path: '/administration/bank',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemAdministrationClassificationsRouteRoute =
  InternalSystemAdministrationClassificationsRouteRouteImport.update({
    id: '/administration/classifications',
    path: '/administration/classifications',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemAdministrationElementTypesRoute =
  InternalSystemAdministrationElementTypesRouteImport.update({
    id: '/administration/element-types',
    path: '/administration/element-types',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemAdministrationMcpRoute =
  InternalSystemAdministrationMcpRouteImport.update({
    id: '/administration/mcp',
    path: '/administration/mcp',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemAdministrationPartiesRoute =
  InternalSystemAdministrationPartiesRouteImport.update({
    id: '/administration/parties',
    path: '/administration/parties',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemAdministrationPaymentPlansRoute =
  InternalSystemAdministrationPaymentPlansRouteImport.update({
    id: '/administration/payment-plans',
    path: '/administration/payment-plans',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemAdministrationProductPropertiesRoute =
  InternalSystemAdministrationProductPropertiesRouteImport.update({
    id: '/administration/product-properties',
    path: '/administration/product-properties',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemAdministrationUsersRoute =
  InternalSystemAdministrationUsersRouteImport.update({
    id: '/administration/users',
    path: '/administration/users',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemDevelopmentIndexRoute =
  InternalSystemDevelopmentIndexRouteImport.update({
    id: '/development/',
    path: '/development/',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemDevelopmentSyncRoute =
  InternalSystemDevelopmentSyncRouteImport.update({
    id: '/development/sync',
    path: '/development/sync',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemOperationsIndexRoute =
  InternalSystemOperationsIndexRouteImport.update({
    id: '/operations/',
    path: '/operations/',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemOperationsBackupRoute =
  InternalSystemOperationsBackupRouteImport.update({
    id: '/operations/backup',
    path: '/operations/backup',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemOperationsEmailRouteRoute =
  InternalSystemOperationsEmailRouteRouteImport.update({
    id: '/operations/email',
    path: '/operations/email',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemOperationsHistoryRoute =
  InternalSystemOperationsHistoryRouteImport.update({
    id: '/operations/history',
    path: '/operations/history',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemOperationsHousekeepingRoute =
  InternalSystemOperationsHousekeepingRouteImport.update({
    id: '/operations/housekeeping',
    path: '/operations/housekeeping',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemOperationsLogsRoute =
  InternalSystemOperationsLogsRouteImport.update({
    id: '/operations/logs',
    path: '/operations/logs',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemOperationsPermissionsRoute =
  InternalSystemOperationsPermissionsRouteImport.update({
    id: '/operations/permissions',
    path: '/operations/permissions',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemOperationsQueueRoute =
  InternalSystemOperationsQueueRouteImport.update({
    id: '/operations/queue',
    path: '/operations/queue',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemOperationsSuggestionsRoute =
  InternalSystemOperationsSuggestionsRouteImport.update({
    id: '/operations/suggestions',
    path: '/operations/suggestions',
    getParentRoute: () => InternalSystemRouteRoute,
  } as any)
const InternalSystemSettingsIndexRoute =
  InternalSystemSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InternalSystemSettingsRouteRoute,
  } as any)
const InternalSystemSettingsAdvisorRoute =
  InternalSystemSettingsAdvisorRouteImport.update({
    id: '/advisor',
    path: '/advisor',
    getParentRoute: () => InternalSystemSettingsRouteRoute,
  } as any)
const InternalSystemSettingsAiRoute =
  InternalSystemSettingsAiRouteImport.update({
    id: '/ai',
    path: '/ai',
    getParentRoute: () => InternalSystemSettingsRouteRoute,
  } as any)
const InternalSystemSettingsCleanupRoute =
  InternalSystemSettingsCleanupRouteImport.update({
    id: '/cleanup',
    path: '/cleanup',
    getParentRoute: () => InternalSystemSettingsRouteRoute,
  } as any)
const InternalSystemSettingsEmailRoute =
  InternalSystemSettingsEmailRouteImport.update({
    id: '/email',
    path: '/email',
    getParentRoute: () => InternalSystemSettingsRouteRoute,
  } as any)
const InternalSystemSettingsHubspotRoute =
  InternalSystemSettingsHubspotRouteImport.update({
    id: '/hubspot',
    path: '/hubspot',
    getParentRoute: () => InternalSystemSettingsRouteRoute,
  } as any)
const InternalSystemSettingsImagesRoute =
  InternalSystemSettingsImagesRouteImport.update({
    id: '/images',
    path: '/images',
    getParentRoute: () => InternalSystemSettingsRouteRoute,
  } as any)
const InternalCustomerViewUserIdProjectIndexRoute =
  InternalCustomerViewUserIdProjectIndexRouteImport.update({
    id: '/project/',
    path: '/project/',
    getParentRoute: () => InternalCustomerViewUserIdRouteRoute,
  } as any)
const InternalCustomerViewUserIdProjectProjectIdRouteRoute =
  InternalCustomerViewUserIdProjectProjectIdRouteRouteImport.update({
    id: '/project/$projectId',
    path: '/project/$projectId',
    getParentRoute: () => InternalCustomerViewUserIdRouteRoute,
  } as any)
const InternalSystemAdministrationClassificationsIndexRoute =
  InternalSystemAdministrationClassificationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InternalSystemAdministrationClassificationsRouteRoute,
  } as any)
const InternalSystemAdministrationClassificationsCategoriesRoute =
  InternalSystemAdministrationClassificationsCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => InternalSystemAdministrationClassificationsRouteRoute,
  } as any)
const InternalSystemAdministrationClassificationsDesignLinesRoute =
  InternalSystemAdministrationClassificationsDesignLinesRouteImport.update({
    id: '/design-lines',
    path: '/design-lines',
    getParentRoute: () => InternalSystemAdministrationClassificationsRouteRoute,
  } as any)
const InternalSystemAdministrationClassificationsGroupsRoute =
  InternalSystemAdministrationClassificationsGroupsRouteImport.update({
    id: '/groups',
    path: '/groups',
    getParentRoute: () => InternalSystemAdministrationClassificationsRouteRoute,
  } as any)
const InternalSystemAdministrationClassificationsStandardsRoute =
  InternalSystemAdministrationClassificationsStandardsRouteImport.update({
    id: '/standards',
    path: '/standards',
    getParentRoute: () => InternalSystemAdministrationClassificationsRouteRoute,
  } as any)
const InternalSystemOperationsEmailIndexRoute =
  InternalSystemOperationsEmailIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InternalSystemOperationsEmailRouteRoute,
  } as any)
const InternalSystemOperationsEmailSubscriptionsRoute =
  InternalSystemOperationsEmailSubscriptionsRouteImport.update({
    id: '/subscriptions',
    path: '/subscriptions',
    getParentRoute: () => InternalSystemOperationsEmailRouteRoute,
  } as any)
const InternalCustomerViewUserIdProjectProjectIdIndexRoute =
  InternalCustomerViewUserIdProjectProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => InternalCustomerViewUserIdProjectProjectIdRouteRoute,
  } as any)
const InternalCustomerViewUserIdProjectProjectIdConfigureRoute =
  InternalCustomerViewUserIdProjectProjectIdConfigureRouteImport.update({
    id: '/configure',
    path: '/configure',
    getParentRoute: () => InternalCustomerViewUserIdProjectProjectIdRouteRoute,
  } as any)
const InternalCustomerViewUserIdProjectProjectIdSummaryRoute =
  InternalCustomerViewUserIdProjectProjectIdSummaryRouteImport.update({
    id: '/summary',
    path: '/summary',
    getParentRoute: () => InternalCustomerViewUserIdProjectProjectIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/customer': typeof CustomerRouteRouteWithChildren
  '/internal': typeof InternalRouteRouteWithChildren
  '/public': typeof PublicRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/internal/system': typeof InternalSystemRouteRouteWithChildren
  '/customer/account': typeof CustomerAccountRoute
  '/customer/dashboard': typeof CustomerDashboardRoute
  '/customer/matches': typeof CustomerMatchesRoute
  '/internal/account': typeof InternalAccountRoute
  '/internal/catalogue': typeof InternalCatalogueRoute
  '/internal/dashboard': typeof InternalDashboardRoute
  '/internal/matching': typeof InternalMatchingRoute
  '/internal/media': typeof InternalMediaRoute
  '/internal/properties': typeof InternalPropertiesRoute
  '/mcp/consent': typeof McpConsentRoute
  '/password-reset/$token': typeof PasswordResetTokenRoute
  '/styleguide/customer': typeof StyleguideCustomerRoute
  '/styleguide/internal': typeof StyleguideInternalRoute
  '/upload/$token': typeof UploadTokenRoute
  '/styleguide/': typeof StyleguideIndexRoute
  '/customer/project/$projectId': typeof CustomerProjectProjectIdRouteRouteWithChildren
  '/internal/customer-view/$userId': typeof InternalCustomerViewUserIdRouteRouteWithChildren
  '/internal/projects/$id': typeof InternalProjectsIdRouteRouteWithChildren
  '/internal/system/settings': typeof InternalSystemSettingsRouteRouteWithChildren
  '/internal/system/configurator': typeof InternalSystemConfiguratorRoute
  '/public/configurator/summary': typeof PublicConfiguratorSummaryRoute
  '/public/projects/$id': typeof PublicProjectsIdRoute
  '/public/unsubscribe/$token': typeof PublicUnsubscribeTokenRoute
  '/customer/project/': typeof CustomerProjectIndexRoute
  '/internal/projects/': typeof InternalProjectsIndexRoute
  '/internal/system/': typeof InternalSystemIndexRoute
  '/public/configurator/': typeof PublicConfiguratorIndexRoute
  '/public/projects-preview/': typeof PublicProjectsPreviewIndexRoute
  '/public/projects/': typeof PublicProjectsIndexRoute
  '/internal/system/administration/classifications': typeof InternalSystemAdministrationClassificationsRouteRouteWithChildren
  '/internal/system/operations/email': typeof InternalSystemOperationsEmailRouteRouteWithChildren
  '/customer/project/$projectId/configure': typeof CustomerProjectProjectIdConfigureRoute
  '/customer/project/$projectId/summary': typeof CustomerProjectProjectIdSummaryRoute
  '/internal/customer-view/$userId/dashboard': typeof InternalCustomerViewUserIdDashboardRoute
  '/internal/customer-view/$userId/matches': typeof InternalCustomerViewUserIdMatchesRoute
  '/internal/projects/$id/documents': typeof InternalProjectsIdDocumentsRoute
  '/internal/projects/$id/finance': typeof InternalProjectsIdFinanceRoute
  '/internal/projects/$id/overview': typeof InternalProjectsIdOverviewRoute
  '/internal/projects/$id/planning': typeof InternalProjectsIdPlanningRoute
  '/internal/system/administration/bank': typeof InternalSystemAdministrationBankRoute
  '/internal/system/administration/element-types': typeof InternalSystemAdministrationElementTypesRoute
  '/internal/system/administration/mcp': typeof InternalSystemAdministrationMcpRoute
  '/internal/system/administration/parties': typeof InternalSystemAdministrationPartiesRoute
  '/internal/system/administration/payment-plans': typeof InternalSystemAdministrationPaymentPlansRoute
  '/internal/system/administration/product-properties': typeof InternalSystemAdministrationProductPropertiesRoute
  '/internal/system/administration/users': typeof InternalSystemAdministrationUsersRoute
  '/internal/system/development/sync': typeof InternalSystemDevelopmentSyncRoute
  '/internal/system/operations/backup': typeof InternalSystemOperationsBackupRoute
  '/internal/system/operations/history': typeof InternalSystemOperationsHistoryRoute
  '/internal/system/operations/housekeeping': typeof InternalSystemOperationsHousekeepingRoute
  '/internal/system/operations/logs': typeof InternalSystemOperationsLogsRoute
  '/internal/system/operations/permissions': typeof InternalSystemOperationsPermissionsRoute
  '/internal/system/operations/queue': typeof InternalSystemOperationsQueueRoute
  '/internal/system/operations/suggestions': typeof InternalSystemOperationsSuggestionsRoute
  '/internal/system/settings/advisor': typeof InternalSystemSettingsAdvisorRoute
  '/internal/system/settings/ai': typeof InternalSystemSettingsAiRoute
  '/internal/system/settings/cleanup': typeof InternalSystemSettingsCleanupRoute
  '/internal/system/settings/email': typeof InternalSystemSettingsEmailRoute
  '/internal/system/settings/hubspot': typeof InternalSystemSettingsHubspotRoute
  '/internal/system/settings/images': typeof InternalSystemSettingsImagesRoute
  '/customer/project/$projectId/': typeof CustomerProjectProjectIdIndexRoute
  '/internal/customer-view/$userId/': typeof InternalCustomerViewUserIdIndexRoute
  '/internal/projects/$id/': typeof InternalProjectsIdIndexRoute
  '/internal/system/administration/': typeof InternalSystemAdministrationIndexRoute
  '/internal/system/development/': typeof InternalSystemDevelopmentIndexRoute
  '/internal/system/operations/': typeof InternalSystemOperationsIndexRoute
  '/internal/system/settings/': typeof InternalSystemSettingsIndexRoute
  '/internal/customer-view/$userId/project/$projectId': typeof InternalCustomerViewUserIdProjectProjectIdRouteRouteWithChildren
  '/internal/system/administration/classifications/categories': typeof InternalSystemAdministrationClassificationsCategoriesRoute
  '/internal/system/administration/classifications/design-lines': typeof InternalSystemAdministrationClassificationsDesignLinesRoute
  '/internal/system/administration/classifications/groups': typeof InternalSystemAdministrationClassificationsGroupsRoute
  '/internal/system/administration/classifications/standards': typeof InternalSystemAdministrationClassificationsStandardsRoute
  '/internal/system/operations/email/subscriptions': typeof InternalSystemOperationsEmailSubscriptionsRoute
  '/internal/customer-view/$userId/project/': typeof InternalCustomerViewUserIdProjectIndexRoute
  '/internal/system/administration/classifications/': typeof InternalSystemAdministrationClassificationsIndexRoute
  '/internal/system/operations/email/': typeof InternalSystemOperationsEmailIndexRoute
  '/internal/customer-view/$userId/project/$projectId/configure': typeof InternalCustomerViewUserIdProjectProjectIdConfigureRoute
  '/internal/customer-view/$userId/project/$projectId/summary': typeof InternalCustomerViewUserIdProjectProjectIdSummaryRoute
  '/internal/customer-view/$userId/project/$projectId/': typeof InternalCustomerViewUserIdProjectProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/customer': typeof CustomerRouteRouteWithChildren
  '/internal': typeof InternalRouteRouteWithChildren
  '/public': typeof PublicRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/customer/account': typeof CustomerAccountRoute
  '/customer/dashboard': typeof CustomerDashboardRoute
  '/customer/matches': typeof CustomerMatchesRoute
  '/internal/account': typeof InternalAccountRoute
  '/internal/catalogue': typeof InternalCatalogueRoute
  '/internal/dashboard': typeof InternalDashboardRoute
  '/internal/matching': typeof InternalMatchingRoute
  '/internal/media': typeof InternalMediaRoute
  '/internal/properties': typeof InternalPropertiesRoute
  '/mcp/consent': typeof McpConsentRoute
  '/password-reset/$token': typeof PasswordResetTokenRoute
  '/styleguide/customer': typeof StyleguideCustomerRoute
  '/styleguide/internal': typeof StyleguideInternalRoute
  '/upload/$token': typeof UploadTokenRoute
  '/styleguide': typeof StyleguideIndexRoute
  '/internal/system/configurator': typeof InternalSystemConfiguratorRoute
  '/public/configurator/summary': typeof PublicConfiguratorSummaryRoute
  '/public/projects/$id': typeof PublicProjectsIdRoute
  '/public/unsubscribe/$token': typeof PublicUnsubscribeTokenRoute
  '/customer/project': typeof CustomerProjectIndexRoute
  '/internal/projects': typeof InternalProjectsIndexRoute
  '/internal/system': typeof InternalSystemIndexRoute
  '/public/configurator': typeof PublicConfiguratorIndexRoute
  '/public/projects-preview': typeof PublicProjectsPreviewIndexRoute
  '/public/projects': typeof PublicProjectsIndexRoute
  '/customer/project/$projectId/configure': typeof CustomerProjectProjectIdConfigureRoute
  '/customer/project/$projectId/summary': typeof CustomerProjectProjectIdSummaryRoute
  '/internal/customer-view/$userId/dashboard': typeof InternalCustomerViewUserIdDashboardRoute
  '/internal/customer-view/$userId/matches': typeof InternalCustomerViewUserIdMatchesRoute
  '/internal/projects/$id/documents': typeof InternalProjectsIdDocumentsRoute
  '/internal/projects/$id/finance': typeof InternalProjectsIdFinanceRoute
  '/internal/projects/$id/overview': typeof InternalProjectsIdOverviewRoute
  '/internal/projects/$id/planning': typeof InternalProjectsIdPlanningRoute
  '/internal/system/administration/bank': typeof InternalSystemAdministrationBankRoute
  '/internal/system/administration/element-types': typeof InternalSystemAdministrationElementTypesRoute
  '/internal/system/administration/mcp': typeof InternalSystemAdministrationMcpRoute
  '/internal/system/administration/parties': typeof InternalSystemAdministrationPartiesRoute
  '/internal/system/administration/payment-plans': typeof InternalSystemAdministrationPaymentPlansRoute
  '/internal/system/administration/product-properties': typeof InternalSystemAdministrationProductPropertiesRoute
  '/internal/system/administration/users': typeof InternalSystemAdministrationUsersRoute
  '/internal/system/development/sync': typeof InternalSystemDevelopmentSyncRoute
  '/internal/system/operations/backup': typeof InternalSystemOperationsBackupRoute
  '/internal/system/operations/history': typeof InternalSystemOperationsHistoryRoute
  '/internal/system/operations/housekeeping': typeof InternalSystemOperationsHousekeepingRoute
  '/internal/system/operations/logs': typeof InternalSystemOperationsLogsRoute
  '/internal/system/operations/permissions': typeof InternalSystemOperationsPermissionsRoute
  '/internal/system/operations/queue': typeof InternalSystemOperationsQueueRoute
  '/internal/system/operations/suggestions': typeof InternalSystemOperationsSuggestionsRoute
  '/internal/system/settings/advisor': typeof InternalSystemSettingsAdvisorRoute
  '/internal/system/settings/ai': typeof InternalSystemSettingsAiRoute
  '/internal/system/settings/cleanup': typeof InternalSystemSettingsCleanupRoute
  '/internal/system/settings/email': typeof InternalSystemSettingsEmailRoute
  '/internal/system/settings/hubspot': typeof InternalSystemSettingsHubspotRoute
  '/internal/system/settings/images': typeof InternalSystemSettingsImagesRoute
  '/customer/project/$projectId': typeof CustomerProjectProjectIdIndexRoute
  '/internal/customer-view/$userId': typeof InternalCustomerViewUserIdIndexRoute
  '/internal/projects/$id': typeof InternalProjectsIdIndexRoute
  '/internal/system/administration': typeof InternalSystemAdministrationIndexRoute
  '/internal/system/development': typeof InternalSystemDevelopmentIndexRoute
  '/internal/system/operations': typeof InternalSystemOperationsIndexRoute
  '/internal/system/settings': typeof InternalSystemSettingsIndexRoute
  '/internal/system/administration/classifications/categories': typeof InternalSystemAdministrationClassificationsCategoriesRoute
  '/internal/system/administration/classifications/design-lines': typeof InternalSystemAdministrationClassificationsDesignLinesRoute
  '/internal/system/administration/classifications/groups': typeof InternalSystemAdministrationClassificationsGroupsRoute
  '/internal/system/administration/classifications/standards': typeof InternalSystemAdministrationClassificationsStandardsRoute
  '/internal/system/operations/email/subscriptions': typeof InternalSystemOperationsEmailSubscriptionsRoute
  '/internal/customer-view/$userId/project': typeof InternalCustomerViewUserIdProjectIndexRoute
  '/internal/system/administration/classifications': typeof InternalSystemAdministrationClassificationsIndexRoute
  '/internal/system/operations/email': typeof InternalSystemOperationsEmailIndexRoute
  '/internal/customer-view/$userId/project/$projectId/configure': typeof InternalCustomerViewUserIdProjectProjectIdConfigureRoute
  '/internal/customer-view/$userId/project/$projectId/summary': typeof InternalCustomerViewUserIdProjectProjectIdSummaryRoute
  '/internal/customer-view/$userId/project/$projectId': typeof InternalCustomerViewUserIdProjectProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/customer': typeof CustomerRouteRouteWithChildren
  '/internal': typeof InternalRouteRouteWithChildren
  '/public': typeof PublicRouteRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/internal/system': typeof InternalSystemRouteRouteWithChildren
  '/customer/account': typeof CustomerAccountRoute
  '/customer/dashboard': typeof CustomerDashboardRoute
  '/customer/matches': typeof CustomerMatchesRoute
  '/internal/account': typeof InternalAccountRoute
  '/internal/catalogue': typeof InternalCatalogueRoute
  '/internal/dashboard': typeof InternalDashboardRoute
  '/internal/matching': typeof InternalMatchingRoute
  '/internal/media': typeof InternalMediaRoute
  '/internal/properties': typeof InternalPropertiesRoute
  '/mcp/consent': typeof McpConsentRoute
  '/password-reset/$token': typeof PasswordResetTokenRoute
  '/styleguide/customer': typeof StyleguideCustomerRoute
  '/styleguide/internal': typeof StyleguideInternalRoute
  '/upload/$token': typeof UploadTokenRoute
  '/styleguide/': typeof StyleguideIndexRoute
  '/customer/project/$projectId': typeof CustomerProjectProjectIdRouteRouteWithChildren
  '/internal/customer-view/$userId': typeof InternalCustomerViewUserIdRouteRouteWithChildren
  '/internal/projects/$id': typeof InternalProjectsIdRouteRouteWithChildren
  '/internal/system/settings': typeof InternalSystemSettingsRouteRouteWithChildren
  '/internal/system/configurator': typeof InternalSystemConfiguratorRoute
  '/public/configurator/summary': typeof PublicConfiguratorSummaryRoute
  '/public/projects/$id': typeof PublicProjectsIdRoute
  '/public/unsubscribe/$token': typeof PublicUnsubscribeTokenRoute
  '/customer/project/': typeof CustomerProjectIndexRoute
  '/internal/projects/': typeof InternalProjectsIndexRoute
  '/internal/system/': typeof InternalSystemIndexRoute
  '/public/configurator/': typeof PublicConfiguratorIndexRoute
  '/public/projects-preview/': typeof PublicProjectsPreviewIndexRoute
  '/public/projects/': typeof PublicProjectsIndexRoute
  '/internal/system/administration/classifications': typeof InternalSystemAdministrationClassificationsRouteRouteWithChildren
  '/internal/system/operations/email': typeof InternalSystemOperationsEmailRouteRouteWithChildren
  '/customer/project/$projectId/configure': typeof CustomerProjectProjectIdConfigureRoute
  '/customer/project/$projectId/summary': typeof CustomerProjectProjectIdSummaryRoute
  '/internal/customer-view/$userId/dashboard': typeof InternalCustomerViewUserIdDashboardRoute
  '/internal/customer-view/$userId/matches': typeof InternalCustomerViewUserIdMatchesRoute
  '/internal/projects/$id/documents': typeof InternalProjectsIdDocumentsRoute
  '/internal/projects/$id/finance': typeof InternalProjectsIdFinanceRoute
  '/internal/projects/$id/overview': typeof InternalProjectsIdOverviewRoute
  '/internal/projects/$id/planning': typeof InternalProjectsIdPlanningRoute
  '/internal/system/administration/bank': typeof InternalSystemAdministrationBankRoute
  '/internal/system/administration/element-types': typeof InternalSystemAdministrationElementTypesRoute
  '/internal/system/administration/mcp': typeof InternalSystemAdministrationMcpRoute
  '/internal/system/administration/parties': typeof InternalSystemAdministrationPartiesRoute
  '/internal/system/administration/payment-plans': typeof InternalSystemAdministrationPaymentPlansRoute
  '/internal/system/administration/product-properties': typeof InternalSystemAdministrationProductPropertiesRoute
  '/internal/system/administration/users': typeof InternalSystemAdministrationUsersRoute
  '/internal/system/development/sync': typeof InternalSystemDevelopmentSyncRoute
  '/internal/system/operations/backup': typeof InternalSystemOperationsBackupRoute
  '/internal/system/operations/history': typeof InternalSystemOperationsHistoryRoute
  '/internal/system/operations/housekeeping': typeof InternalSystemOperationsHousekeepingRoute
  '/internal/system/operations/logs': typeof InternalSystemOperationsLogsRoute
  '/internal/system/operations/permissions': typeof InternalSystemOperationsPermissionsRoute
  '/internal/system/operations/queue': typeof InternalSystemOperationsQueueRoute
  '/internal/system/operations/suggestions': typeof InternalSystemOperationsSuggestionsRoute
  '/internal/system/settings/advisor': typeof InternalSystemSettingsAdvisorRoute
  '/internal/system/settings/ai': typeof InternalSystemSettingsAiRoute
  '/internal/system/settings/cleanup': typeof InternalSystemSettingsCleanupRoute
  '/internal/system/settings/email': typeof InternalSystemSettingsEmailRoute
  '/internal/system/settings/hubspot': typeof InternalSystemSettingsHubspotRoute
  '/internal/system/settings/images': typeof InternalSystemSettingsImagesRoute
  '/customer/project/$projectId/': typeof CustomerProjectProjectIdIndexRoute
  '/internal/customer-view/$userId/': typeof InternalCustomerViewUserIdIndexRoute
  '/internal/projects/$id/': typeof InternalProjectsIdIndexRoute
  '/internal/system/administration/': typeof InternalSystemAdministrationIndexRoute
  '/internal/system/development/': typeof InternalSystemDevelopmentIndexRoute
  '/internal/system/operations/': typeof InternalSystemOperationsIndexRoute
  '/internal/system/settings/': typeof InternalSystemSettingsIndexRoute
  '/internal/customer-view/$userId/project/$projectId': typeof InternalCustomerViewUserIdProjectProjectIdRouteRouteWithChildren
  '/internal/system/administration/classifications/categories': typeof InternalSystemAdministrationClassificationsCategoriesRoute
  '/internal/system/administration/classifications/design-lines': typeof InternalSystemAdministrationClassificationsDesignLinesRoute
  '/internal/system/administration/classifications/groups': typeof InternalSystemAdministrationClassificationsGroupsRoute
  '/internal/system/administration/classifications/standards': typeof InternalSystemAdministrationClassificationsStandardsRoute
  '/internal/system/operations/email/subscriptions': typeof InternalSystemOperationsEmailSubscriptionsRoute
  '/internal/customer-view/$userId/project/': typeof InternalCustomerViewUserIdProjectIndexRoute
  '/internal/system/administration/classifications/': typeof InternalSystemAdministrationClassificationsIndexRoute
  '/internal/system/operations/email/': typeof InternalSystemOperationsEmailIndexRoute
  '/internal/customer-view/$userId/project/$projectId/configure': typeof InternalCustomerViewUserIdProjectProjectIdConfigureRoute
  '/internal/customer-view/$userId/project/$projectId/summary': typeof InternalCustomerViewUserIdProjectProjectIdSummaryRoute
  '/internal/customer-view/$userId/project/$projectId/': typeof InternalCustomerViewUserIdProjectProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/customer'
    | '/internal'
    | '/public'
    | '/forgot-password'
    | '/login'
    | '/internal/system'
    | '/customer/account'
    | '/customer/dashboard'
    | '/customer/matches'
    | '/internal/account'
    | '/internal/catalogue'
    | '/internal/dashboard'
    | '/internal/matching'
    | '/internal/media'
    | '/internal/properties'
    | '/mcp/consent'
    | '/password-reset/$token'
    | '/styleguide/customer'
    | '/styleguide/internal'
    | '/upload/$token'
    | '/styleguide/'
    | '/customer/project/$projectId'
    | '/internal/customer-view/$userId'
    | '/internal/projects/$id'
    | '/internal/system/settings'
    | '/internal/system/configurator'
    | '/public/configurator/summary'
    | '/public/projects/$id'
    | '/public/unsubscribe/$token'
    | '/customer/project/'
    | '/internal/projects/'
    | '/internal/system/'
    | '/public/configurator/'
    | '/public/projects-preview/'
    | '/public/projects/'
    | '/internal/system/administration/classifications'
    | '/internal/system/operations/email'
    | '/customer/project/$projectId/configure'
    | '/customer/project/$projectId/summary'
    | '/internal/customer-view/$userId/dashboard'
    | '/internal/customer-view/$userId/matches'
    | '/internal/projects/$id/documents'
    | '/internal/projects/$id/finance'
    | '/internal/projects/$id/overview'
    | '/internal/projects/$id/planning'
    | '/internal/system/administration/bank'
    | '/internal/system/administration/element-types'
    | '/internal/system/administration/mcp'
    | '/internal/system/administration/parties'
    | '/internal/system/administration/payment-plans'
    | '/internal/system/administration/product-properties'
    | '/internal/system/administration/users'
    | '/internal/system/development/sync'
    | '/internal/system/operations/backup'
    | '/internal/system/operations/history'
    | '/internal/system/operations/housekeeping'
    | '/internal/system/operations/logs'
    | '/internal/system/operations/permissions'
    | '/internal/system/operations/queue'
    | '/internal/system/operations/suggestions'
    | '/internal/system/settings/advisor'
    | '/internal/system/settings/ai'
    | '/internal/system/settings/cleanup'
    | '/internal/system/settings/email'
    | '/internal/system/settings/hubspot'
    | '/internal/system/settings/images'
    | '/customer/project/$projectId/'
    | '/internal/customer-view/$userId/'
    | '/internal/projects/$id/'
    | '/internal/system/administration/'
    | '/internal/system/development/'
    | '/internal/system/operations/'
    | '/internal/system/settings/'
    | '/internal/customer-view/$userId/project/$projectId'
    | '/internal/system/administration/classifications/categories'
    | '/internal/system/administration/classifications/design-lines'
    | '/internal/system/administration/classifications/groups'
    | '/internal/system/administration/classifications/standards'
    | '/internal/system/operations/email/subscriptions'
    | '/internal/customer-view/$userId/project/'
    | '/internal/system/administration/classifications/'
    | '/internal/system/operations/email/'
    | '/internal/customer-view/$userId/project/$projectId/configure'
    | '/internal/customer-view/$userId/project/$projectId/summary'
    | '/internal/customer-view/$userId/project/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/customer'
    | '/internal'
    | '/public'
    | '/forgot-password'
    | '/login'
    | '/customer/account'
    | '/customer/dashboard'
    | '/customer/matches'
    | '/internal/account'
    | '/internal/catalogue'
    | '/internal/dashboard'
    | '/internal/matching'
    | '/internal/media'
    | '/internal/properties'
    | '/mcp/consent'
    | '/password-reset/$token'
    | '/styleguide/customer'
    | '/styleguide/internal'
    | '/upload/$token'
    | '/styleguide'
    | '/internal/system/configurator'
    | '/public/configurator/summary'
    | '/public/projects/$id'
    | '/public/unsubscribe/$token'
    | '/customer/project'
    | '/internal/projects'
    | '/internal/system'
    | '/public/configurator'
    | '/public/projects-preview'
    | '/public/projects'
    | '/customer/project/$projectId/configure'
    | '/customer/project/$projectId/summary'
    | '/internal/customer-view/$userId/dashboard'
    | '/internal/customer-view/$userId/matches'
    | '/internal/projects/$id/documents'
    | '/internal/projects/$id/finance'
    | '/internal/projects/$id/overview'
    | '/internal/projects/$id/planning'
    | '/internal/system/administration/bank'
    | '/internal/system/administration/element-types'
    | '/internal/system/administration/mcp'
    | '/internal/system/administration/parties'
    | '/internal/system/administration/payment-plans'
    | '/internal/system/administration/product-properties'
    | '/internal/system/administration/users'
    | '/internal/system/development/sync'
    | '/internal/system/operations/backup'
    | '/internal/system/operations/history'
    | '/internal/system/operations/housekeeping'
    | '/internal/system/operations/logs'
    | '/internal/system/operations/permissions'
    | '/internal/system/operations/queue'
    | '/internal/system/operations/suggestions'
    | '/internal/system/settings/advisor'
    | '/internal/system/settings/ai'
    | '/internal/system/settings/cleanup'
    | '/internal/system/settings/email'
    | '/internal/system/settings/hubspot'
    | '/internal/system/settings/images'
    | '/customer/project/$projectId'
    | '/internal/customer-view/$userId'
    | '/internal/projects/$id'
    | '/internal/system/administration'
    | '/internal/system/development'
    | '/internal/system/operations'
    | '/internal/system/settings'
    | '/internal/system/administration/classifications/categories'
    | '/internal/system/administration/classifications/design-lines'
    | '/internal/system/administration/classifications/groups'
    | '/internal/system/administration/classifications/standards'
    | '/internal/system/operations/email/subscriptions'
    | '/internal/customer-view/$userId/project'
    | '/internal/system/administration/classifications'
    | '/internal/system/operations/email'
    | '/internal/customer-view/$userId/project/$projectId/configure'
    | '/internal/customer-view/$userId/project/$projectId/summary'
    | '/internal/customer-view/$userId/project/$projectId'
  id:
    | '__root__'
    | '/'
    | '/customer'
    | '/internal'
    | '/public'
    | '/forgot-password'
    | '/login'
    | '/internal/system'
    | '/customer/account'
    | '/customer/dashboard'
    | '/customer/matches'
    | '/internal/account'
    | '/internal/catalogue'
    | '/internal/dashboard'
    | '/internal/matching'
    | '/internal/media'
    | '/internal/properties'
    | '/mcp/consent'
    | '/password-reset/$token'
    | '/styleguide/customer'
    | '/styleguide/internal'
    | '/upload/$token'
    | '/styleguide/'
    | '/customer/project/$projectId'
    | '/internal/customer-view/$userId'
    | '/internal/projects/$id'
    | '/internal/system/settings'
    | '/internal/system/configurator'
    | '/public/configurator/summary'
    | '/public/projects/$id'
    | '/public/unsubscribe/$token'
    | '/customer/project/'
    | '/internal/projects/'
    | '/internal/system/'
    | '/public/configurator/'
    | '/public/projects-preview/'
    | '/public/projects/'
    | '/internal/system/administration/classifications'
    | '/internal/system/operations/email'
    | '/customer/project/$projectId/configure'
    | '/customer/project/$projectId/summary'
    | '/internal/customer-view/$userId/dashboard'
    | '/internal/customer-view/$userId/matches'
    | '/internal/projects/$id/documents'
    | '/internal/projects/$id/finance'
    | '/internal/projects/$id/overview'
    | '/internal/projects/$id/planning'
    | '/internal/system/administration/bank'
    | '/internal/system/administration/element-types'
    | '/internal/system/administration/mcp'
    | '/internal/system/administration/parties'
    | '/internal/system/administration/payment-plans'
    | '/internal/system/administration/product-properties'
    | '/internal/system/administration/users'
    | '/internal/system/development/sync'
    | '/internal/system/operations/backup'
    | '/internal/system/operations/history'
    | '/internal/system/operations/housekeeping'
    | '/internal/system/operations/logs'
    | '/internal/system/operations/permissions'
    | '/internal/system/operations/queue'
    | '/internal/system/operations/suggestions'
    | '/internal/system/settings/advisor'
    | '/internal/system/settings/ai'
    | '/internal/system/settings/cleanup'
    | '/internal/system/settings/email'
    | '/internal/system/settings/hubspot'
    | '/internal/system/settings/images'
    | '/customer/project/$projectId/'
    | '/internal/customer-view/$userId/'
    | '/internal/projects/$id/'
    | '/internal/system/administration/'
    | '/internal/system/development/'
    | '/internal/system/operations/'
    | '/internal/system/settings/'
    | '/internal/customer-view/$userId/project/$projectId'
    | '/internal/system/administration/classifications/categories'
    | '/internal/system/administration/classifications/design-lines'
    | '/internal/system/administration/classifications/groups'
    | '/internal/system/administration/classifications/standards'
    | '/internal/system/operations/email/subscriptions'
    | '/internal/customer-view/$userId/project/'
    | '/internal/system/administration/classifications/'
    | '/internal/system/operations/email/'
    | '/internal/customer-view/$userId/project/$projectId/configure'
    | '/internal/customer-view/$userId/project/$projectId/summary'
    | '/internal/customer-view/$userId/project/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CustomerRouteRoute: typeof CustomerRouteRouteWithChildren
  InternalRouteRoute: typeof InternalRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  McpConsentRoute: typeof McpConsentRoute
  PasswordResetTokenRoute: typeof PasswordResetTokenRoute
  StyleguideCustomerRoute: typeof StyleguideCustomerRoute
  StyleguideInternalRoute: typeof StyleguideInternalRoute
  UploadTokenRoute: typeof UploadTokenRoute
  StyleguideIndexRoute: typeof StyleguideIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer': {
      id: '/customer'
      path: '/customer'
      fullPath: '/customer'
      preLoaderRoute: typeof CustomerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/internal': {
      id: '/internal'
      path: '/internal'
      fullPath: '/internal'
      preLoaderRoute: typeof InternalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public': {
      id: '/public'
      path: '/public'
      fullPath: '/public'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/account': {
      id: '/customer/account'
      path: '/account'
      fullPath: '/customer/account'
      preLoaderRoute: typeof CustomerAccountRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/customer/dashboard': {
      id: '/customer/dashboard'
      path: '/dashboard'
      fullPath: '/customer/dashboard'
      preLoaderRoute: typeof CustomerDashboardRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/customer/matches': {
      id: '/customer/matches'
      path: '/matches'
      fullPath: '/customer/matches'
      preLoaderRoute: typeof CustomerMatchesRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/internal/account': {
      id: '/internal/account'
      path: '/account'
      fullPath: '/internal/account'
      preLoaderRoute: typeof InternalAccountRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/internal/catalogue': {
      id: '/internal/catalogue'
      path: '/catalogue'
      fullPath: '/internal/catalogue'
      preLoaderRoute: typeof InternalCatalogueRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/internal/dashboard': {
      id: '/internal/dashboard'
      path: '/dashboard'
      fullPath: '/internal/dashboard'
      preLoaderRoute: typeof InternalDashboardRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/internal/matching': {
      id: '/internal/matching'
      path: '/matching'
      fullPath: '/internal/matching'
      preLoaderRoute: typeof InternalMatchingRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/internal/media': {
      id: '/internal/media'
      path: '/media'
      fullPath: '/internal/media'
      preLoaderRoute: typeof InternalMediaRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/internal/properties': {
      id: '/internal/properties'
      path: '/properties'
      fullPath: '/internal/properties'
      preLoaderRoute: typeof InternalPropertiesRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/internal/system': {
      id: '/internal/system'
      path: '/system'
      fullPath: '/internal/system'
      preLoaderRoute: typeof InternalSystemRouteRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/mcp/consent': {
      id: '/mcp/consent'
      path: '/mcp/consent'
      fullPath: '/mcp/consent'
      preLoaderRoute: typeof McpConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password-reset/$token': {
      id: '/password-reset/$token'
      path: '/password-reset/$token'
      fullPath: '/password-reset/$token'
      preLoaderRoute: typeof PasswordResetTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/styleguide/': {
      id: '/styleguide/'
      path: '/styleguide'
      fullPath: '/styleguide/'
      preLoaderRoute: typeof StyleguideIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/styleguide/customer': {
      id: '/styleguide/customer'
      path: '/styleguide/customer'
      fullPath: '/styleguide/customer'
      preLoaderRoute: typeof StyleguideCustomerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/styleguide/internal': {
      id: '/styleguide/internal'
      path: '/styleguide/internal'
      fullPath: '/styleguide/internal'
      preLoaderRoute: typeof StyleguideInternalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upload/$token': {
      id: '/upload/$token'
      path: '/upload/$token'
      fullPath: '/upload/$token'
      preLoaderRoute: typeof UploadTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/customer/project/': {
      id: '/customer/project/'
      path: '/project'
      fullPath: '/customer/project/'
      preLoaderRoute: typeof CustomerProjectIndexRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/customer/project/$projectId': {
      id: '/customer/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/customer/project/$projectId'
      preLoaderRoute: typeof CustomerProjectProjectIdRouteRouteImport
      parentRoute: typeof CustomerRouteRoute
    }
    '/internal/customer-view/$userId': {
      id: '/internal/customer-view/$userId'
      path: '/customer-view/$userId'
      fullPath: '/internal/customer-view/$userId'
      preLoaderRoute: typeof InternalCustomerViewUserIdRouteRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/internal/projects/': {
      id: '/internal/projects/'
      path: '/projects'
      fullPath: '/internal/projects/'
      preLoaderRoute: typeof InternalProjectsIndexRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/internal/projects/$id': {
      id: '/internal/projects/$id'
      path: '/projects/$id'
      fullPath: '/internal/projects/$id'
      preLoaderRoute: typeof InternalProjectsIdRouteRouteImport
      parentRoute: typeof InternalRouteRoute
    }
    '/internal/system/': {
      id: '/internal/system/'
      path: '/'
      fullPath: '/internal/system/'
      preLoaderRoute: typeof InternalSystemIndexRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/configurator': {
      id: '/internal/system/configurator'
      path: '/configurator'
      fullPath: '/internal/system/configurator'
      preLoaderRoute: typeof InternalSystemConfiguratorRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/settings': {
      id: '/internal/system/settings'
      path: '/settings'
      fullPath: '/internal/system/settings'
      preLoaderRoute: typeof InternalSystemSettingsRouteRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/public/configurator/': {
      id: '/public/configurator/'
      path: '/configurator'
      fullPath: '/public/configurator/'
      preLoaderRoute: typeof PublicConfiguratorIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/public/configurator/summary': {
      id: '/public/configurator/summary'
      path: '/configurator/summary'
      fullPath: '/public/configurator/summary'
      preLoaderRoute: typeof PublicConfiguratorSummaryRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/public/projects-preview/': {
      id: '/public/projects-preview/'
      path: '/projects-preview'
      fullPath: '/public/projects-preview/'
      preLoaderRoute: typeof PublicProjectsPreviewIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/public/projects/': {
      id: '/public/projects/'
      path: '/projects'
      fullPath: '/public/projects/'
      preLoaderRoute: typeof PublicProjectsIndexRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/public/projects/$id': {
      id: '/public/projects/$id'
      path: '/projects/$id'
      fullPath: '/public/projects/$id'
      preLoaderRoute: typeof PublicProjectsIdRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/public/unsubscribe/$token': {
      id: '/public/unsubscribe/$token'
      path: '/unsubscribe/$token'
      fullPath: '/public/unsubscribe/$token'
      preLoaderRoute: typeof PublicUnsubscribeTokenRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/customer/project/$projectId/': {
      id: '/customer/project/$projectId/'
      path: '/'
      fullPath: '/customer/project/$projectId/'
      preLoaderRoute: typeof CustomerProjectProjectIdIndexRouteImport
      parentRoute: typeof CustomerProjectProjectIdRouteRoute
    }
    '/customer/project/$projectId/configure': {
      id: '/customer/project/$projectId/configure'
      path: '/configure'
      fullPath: '/customer/project/$projectId/configure'
      preLoaderRoute: typeof CustomerProjectProjectIdConfigureRouteImport
      parentRoute: typeof CustomerProjectProjectIdRouteRoute
    }
    '/customer/project/$projectId/summary': {
      id: '/customer/project/$projectId/summary'
      path: '/summary'
      fullPath: '/customer/project/$projectId/summary'
      preLoaderRoute: typeof CustomerProjectProjectIdSummaryRouteImport
      parentRoute: typeof CustomerProjectProjectIdRouteRoute
    }
    '/internal/customer-view/$userId/': {
      id: '/internal/customer-view/$userId/'
      path: '/'
      fullPath: '/internal/customer-view/$userId/'
      preLoaderRoute: typeof InternalCustomerViewUserIdIndexRouteImport
      parentRoute: typeof InternalCustomerViewUserIdRouteRoute
    }
    '/internal/customer-view/$userId/dashboard': {
      id: '/internal/customer-view/$userId/dashboard'
      path: '/dashboard'
      fullPath: '/internal/customer-view/$userId/dashboard'
      preLoaderRoute: typeof InternalCustomerViewUserIdDashboardRouteImport
      parentRoute: typeof InternalCustomerViewUserIdRouteRoute
    }
    '/internal/customer-view/$userId/matches': {
      id: '/internal/customer-view/$userId/matches'
      path: '/matches'
      fullPath: '/internal/customer-view/$userId/matches'
      preLoaderRoute: typeof InternalCustomerViewUserIdMatchesRouteImport
      parentRoute: typeof InternalCustomerViewUserIdRouteRoute
    }
    '/internal/projects/$id/': {
      id: '/internal/projects/$id/'
      path: '/'
      fullPath: '/internal/projects/$id/'
      preLoaderRoute: typeof InternalProjectsIdIndexRouteImport
      parentRoute: typeof InternalProjectsIdRouteRoute
    }
    '/internal/projects/$id/documents': {
      id: '/internal/projects/$id/documents'
      path: '/documents'
      fullPath: '/internal/projects/$id/documents'
      preLoaderRoute: typeof InternalProjectsIdDocumentsRouteImport
      parentRoute: typeof InternalProjectsIdRouteRoute
    }
    '/internal/projects/$id/finance': {
      id: '/internal/projects/$id/finance'
      path: '/finance'
      fullPath: '/internal/projects/$id/finance'
      preLoaderRoute: typeof InternalProjectsIdFinanceRouteImport
      parentRoute: typeof InternalProjectsIdRouteRoute
    }
    '/internal/projects/$id/overview': {
      id: '/internal/projects/$id/overview'
      path: '/overview'
      fullPath: '/internal/projects/$id/overview'
      preLoaderRoute: typeof InternalProjectsIdOverviewRouteImport
      parentRoute: typeof InternalProjectsIdRouteRoute
    }
    '/internal/projects/$id/planning': {
      id: '/internal/projects/$id/planning'
      path: '/planning'
      fullPath: '/internal/projects/$id/planning'
      preLoaderRoute: typeof InternalProjectsIdPlanningRouteImport
      parentRoute: typeof InternalProjectsIdRouteRoute
    }
    '/internal/system/administration/': {
      id: '/internal/system/administration/'
      path: '/administration'
      fullPath: '/internal/system/administration/'
      preLoaderRoute: typeof InternalSystemAdministrationIndexRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/administration/bank': {
      id: '/internal/system/administration/bank'
      path: '/administration/bank'
      fullPath: '/internal/system/administration/bank'
      preLoaderRoute: typeof InternalSystemAdministrationBankRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/administration/classifications': {
      id: '/internal/system/administration/classifications'
      path: '/administration/classifications'
      fullPath: '/internal/system/administration/classifications'
      preLoaderRoute: typeof InternalSystemAdministrationClassificationsRouteRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/administration/element-types': {
      id: '/internal/system/administration/element-types'
      path: '/administration/element-types'
      fullPath: '/internal/system/administration/element-types'
      preLoaderRoute: typeof InternalSystemAdministrationElementTypesRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/administration/mcp': {
      id: '/internal/system/administration/mcp'
      path: '/administration/mcp'
      fullPath: '/internal/system/administration/mcp'
      preLoaderRoute: typeof InternalSystemAdministrationMcpRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/administration/parties': {
      id: '/internal/system/administration/parties'
      path: '/administration/parties'
      fullPath: '/internal/system/administration/parties'
      preLoaderRoute: typeof InternalSystemAdministrationPartiesRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/administration/payment-plans': {
      id: '/internal/system/administration/payment-plans'
      path: '/administration/payment-plans'
      fullPath: '/internal/system/administration/payment-plans'
      preLoaderRoute: typeof InternalSystemAdministrationPaymentPlansRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/administration/product-properties': {
      id: '/internal/system/administration/product-properties'
      path: '/administration/product-properties'
      fullPath: '/internal/system/administration/product-properties'
      preLoaderRoute: typeof InternalSystemAdministrationProductPropertiesRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/administration/users': {
      id: '/internal/system/administration/users'
      path: '/administration/users'
      fullPath: '/internal/system/administration/users'
      preLoaderRoute: typeof InternalSystemAdministrationUsersRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/development/': {
      id: '/internal/system/development/'
      path: '/development'
      fullPath: '/internal/system/development/'
      preLoaderRoute: typeof InternalSystemDevelopmentIndexRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/development/sync': {
      id: '/internal/system/development/sync'
      path: '/development/sync'
      fullPath: '/internal/system/development/sync'
      preLoaderRoute: typeof InternalSystemDevelopmentSyncRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/operations/': {
      id: '/internal/system/operations/'
      path: '/operations'
      fullPath: '/internal/system/operations/'
      preLoaderRoute: typeof InternalSystemOperationsIndexRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/operations/backup': {
      id: '/internal/system/operations/backup'
      path: '/operations/backup'
      fullPath: '/internal/system/operations/backup'
      preLoaderRoute: typeof InternalSystemOperationsBackupRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/operations/email': {
      id: '/internal/system/operations/email'
      path: '/operations/email'
      fullPath: '/internal/system/operations/email'
      preLoaderRoute: typeof InternalSystemOperationsEmailRouteRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/operations/history': {
      id: '/internal/system/operations/history'
      path: '/operations/history'
      fullPath: '/internal/system/operations/history'
      preLoaderRoute: typeof InternalSystemOperationsHistoryRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/operations/housekeeping': {
      id: '/internal/system/operations/housekeeping'
      path: '/operations/housekeeping'
      fullPath: '/internal/system/operations/housekeeping'
      preLoaderRoute: typeof InternalSystemOperationsHousekeepingRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/operations/logs': {
      id: '/internal/system/operations/logs'
      path: '/operations/logs'
      fullPath: '/internal/system/operations/logs'
      preLoaderRoute: typeof InternalSystemOperationsLogsRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/operations/permissions': {
      id: '/internal/system/operations/permissions'
      path: '/operations/permissions'
      fullPath: '/internal/system/operations/permissions'
      preLoaderRoute: typeof InternalSystemOperationsPermissionsRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/operations/queue': {
      id: '/internal/system/operations/queue'
      path: '/operations/queue'
      fullPath: '/internal/system/operations/queue'
      preLoaderRoute: typeof InternalSystemOperationsQueueRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/operations/suggestions': {
      id: '/internal/system/operations/suggestions'
      path: '/operations/suggestions'
      fullPath: '/internal/system/operations/suggestions'
      preLoaderRoute: typeof InternalSystemOperationsSuggestionsRouteImport
      parentRoute: typeof InternalSystemRouteRoute
    }
    '/internal/system/settings/': {
      id: '/internal/system/settings/'
      path: '/'
      fullPath: '/internal/system/settings/'
      preLoaderRoute: typeof InternalSystemSettingsIndexRouteImport
      parentRoute: typeof InternalSystemSettingsRouteRoute
    }
    '/internal/system/settings/advisor': {
      id: '/internal/system/settings/advisor'
      path: '/advisor'
      fullPath: '/internal/system/settings/advisor'
      preLoaderRoute: typeof InternalSystemSettingsAdvisorRouteImport
      parentRoute: typeof InternalSystemSettingsRouteRoute
    }
    '/internal/system/settings/ai': {
      id: '/internal/system/settings/ai'
      path: '/ai'
      fullPath: '/internal/system/settings/ai'
      preLoaderRoute: typeof InternalSystemSettingsAiRouteImport
      parentRoute: typeof InternalSystemSettingsRouteRoute
    }
    '/internal/system/settings/cleanup': {
      id: '/internal/system/settings/cleanup'
      path: '/cleanup'
      fullPath: '/internal/system/settings/cleanup'
      preLoaderRoute: typeof InternalSystemSettingsCleanupRouteImport
      parentRoute: typeof InternalSystemSettingsRouteRoute
    }
    '/internal/system/settings/email': {
      id: '/internal/system/settings/email'
      path: '/email'
      fullPath: '/internal/system/settings/email'
      preLoaderRoute: typeof InternalSystemSettingsEmailRouteImport
      parentRoute: typeof InternalSystemSettingsRouteRoute
    }
    '/internal/system/settings/hubspot': {
      id: '/internal/system/settings/hubspot'
      path: '/hubspot'
      fullPath: '/internal/system/settings/hubspot'
      preLoaderRoute: typeof InternalSystemSettingsHubspotRouteImport
      parentRoute: typeof InternalSystemSettingsRouteRoute
    }
    '/internal/system/settings/images': {
      id: '/internal/system/settings/images'
      path: '/images'
      fullPath: '/internal/system/settings/images'
      preLoaderRoute: typeof InternalSystemSettingsImagesRouteImport
      parentRoute: typeof InternalSystemSettingsRouteRoute
    }
    '/internal/customer-view/$userId/project/': {
      id: '/internal/customer-view/$userId/project/'
      path: '/project'
      fullPath: '/internal/customer-view/$userId/project/'
      preLoaderRoute: typeof InternalCustomerViewUserIdProjectIndexRouteImport
      parentRoute: typeof InternalCustomerViewUserIdRouteRoute
    }
    '/internal/customer-view/$userId/project/$projectId': {
      id: '/internal/customer-view/$userId/project/$projectId'
      path: '/project/$projectId'
      fullPath: '/internal/customer-view/$userId/project/$projectId'
      preLoaderRoute: typeof InternalCustomerViewUserIdProjectProjectIdRouteRouteImport
      parentRoute: typeof InternalCustomerViewUserIdRouteRoute
    }
    '/internal/system/administration/classifications/': {
      id: '/internal/system/administration/classifications/'
      path: '/'
      fullPath: '/internal/system/administration/classifications/'
      preLoaderRoute: typeof InternalSystemAdministrationClassificationsIndexRouteImport
      parentRoute: typeof InternalSystemAdministrationClassificationsRouteRoute
    }
    '/internal/system/administration/classifications/categories': {
      id: '/internal/system/administration/classifications/categories'
      path: '/categories'
      fullPath: '/internal/system/administration/classifications/categories'
      preLoaderRoute: typeof InternalSystemAdministrationClassificationsCategoriesRouteImport
      parentRoute: typeof InternalSystemAdministrationClassificationsRouteRoute
    }
    '/internal/system/administration/classifications/design-lines': {
      id: '/internal/system/administration/classifications/design-lines'
      path: '/design-lines'
      fullPath: '/internal/system/administration/classifications/design-lines'
      preLoaderRoute: typeof InternalSystemAdministrationClassificationsDesignLinesRouteImport
      parentRoute: typeof InternalSystemAdministrationClassificationsRouteRoute
    }
    '/internal/system/administration/classifications/groups': {
      id: '/internal/system/administration/classifications/groups'
      path: '/groups'
      fullPath: '/internal/system/administration/classifications/groups'
      preLoaderRoute: typeof InternalSystemAdministrationClassificationsGroupsRouteImport
      parentRoute: typeof InternalSystemAdministrationClassificationsRouteRoute
    }
    '/internal/system/administration/classifications/standards': {
      id: '/internal/system/administration/classifications/standards'
      path: '/standards'
      fullPath: '/internal/system/administration/classifications/standards'
      preLoaderRoute: typeof InternalSystemAdministrationClassificationsStandardsRouteImport
      parentRoute: typeof InternalSystemAdministrationClassificationsRouteRoute
    }
    '/internal/system/operations/email/': {
      id: '/internal/system/operations/email/'
      path: '/'
      fullPath: '/internal/system/operations/email/'
      preLoaderRoute: typeof InternalSystemOperationsEmailIndexRouteImport
      parentRoute: typeof InternalSystemOperationsEmailRouteRoute
    }
    '/internal/system/operations/email/subscriptions': {
      id: '/internal/system/operations/email/subscriptions'
      path: '/subscriptions'
      fullPath: '/internal/system/operations/email/subscriptions'
      preLoaderRoute: typeof InternalSystemOperationsEmailSubscriptionsRouteImport
      parentRoute: typeof InternalSystemOperationsEmailRouteRoute
    }
    '/internal/customer-view/$userId/project/$projectId/': {
      id: '/internal/customer-view/$userId/project/$projectId/'
      path: '/'
      fullPath: '/internal/customer-view/$userId/project/$projectId/'
      preLoaderRoute: typeof InternalCustomerViewUserIdProjectProjectIdIndexRouteImport
      parentRoute: typeof InternalCustomerViewUserIdProjectProjectIdRouteRoute
    }
    '/internal/customer-view/$userId/project/$projectId/configure': {
      id: '/internal/customer-view/$userId/project/$projectId/configure'
      path: '/configure'
      fullPath: '/internal/customer-view/$userId/project/$projectId/configure'
      preLoaderRoute: typeof InternalCustomerViewUserIdProjectProjectIdConfigureRouteImport
      parentRoute: typeof InternalCustomerViewUserIdProjectProjectIdRouteRoute
    }
    '/internal/customer-view/$userId/project/$projectId/summary': {
      id: '/internal/customer-view/$userId/project/$projectId/summary'
      path: '/summary'
      fullPath: '/internal/customer-view/$userId/project/$projectId/summary'
      preLoaderRoute: typeof InternalCustomerViewUserIdProjectProjectIdSummaryRouteImport
      parentRoute: typeof InternalCustomerViewUserIdProjectProjectIdRouteRoute
    }
  }
}

interface CustomerProjectProjectIdRouteRouteChildren {
  CustomerProjectProjectIdConfigureRoute: typeof CustomerProjectProjectIdConfigureRoute
  CustomerProjectProjectIdSummaryRoute: typeof CustomerProjectProjectIdSummaryRoute
  CustomerProjectProjectIdIndexRoute: typeof CustomerProjectProjectIdIndexRoute
}

const CustomerProjectProjectIdRouteRouteChildren: CustomerProjectProjectIdRouteRouteChildren =
  {
    CustomerProjectProjectIdConfigureRoute:
      CustomerProjectProjectIdConfigureRoute,
    CustomerProjectProjectIdSummaryRoute: CustomerProjectProjectIdSummaryRoute,
    CustomerProjectProjectIdIndexRoute: CustomerProjectProjectIdIndexRoute,
  }

const CustomerProjectProjectIdRouteRouteWithChildren =
  CustomerProjectProjectIdRouteRoute._addFileChildren(
    CustomerProjectProjectIdRouteRouteChildren,
  )

interface CustomerRouteRouteChildren {
  CustomerAccountRoute: typeof CustomerAccountRoute
  CustomerDashboardRoute: typeof CustomerDashboardRoute
  CustomerMatchesRoute: typeof CustomerMatchesRoute
  CustomerProjectProjectIdRouteRoute: typeof CustomerProjectProjectIdRouteRouteWithChildren
  CustomerProjectIndexRoute: typeof CustomerProjectIndexRoute
}

const CustomerRouteRouteChildren: CustomerRouteRouteChildren = {
  CustomerAccountRoute: CustomerAccountRoute,
  CustomerDashboardRoute: CustomerDashboardRoute,
  CustomerMatchesRoute: CustomerMatchesRoute,
  CustomerProjectProjectIdRouteRoute:
    CustomerProjectProjectIdRouteRouteWithChildren,
  CustomerProjectIndexRoute: CustomerProjectIndexRoute,
}

const CustomerRouteRouteWithChildren = CustomerRouteRoute._addFileChildren(
  CustomerRouteRouteChildren,
)

interface InternalSystemSettingsRouteRouteChildren {
  InternalSystemSettingsAdvisorRoute: typeof InternalSystemSettingsAdvisorRoute
  InternalSystemSettingsAiRoute: typeof InternalSystemSettingsAiRoute
  InternalSystemSettingsCleanupRoute: typeof InternalSystemSettingsCleanupRoute
  InternalSystemSettingsEmailRoute: typeof InternalSystemSettingsEmailRoute
  InternalSystemSettingsHubspotRoute: typeof InternalSystemSettingsHubspotRoute
  InternalSystemSettingsImagesRoute: typeof InternalSystemSettingsImagesRoute
  InternalSystemSettingsIndexRoute: typeof InternalSystemSettingsIndexRoute
}

const InternalSystemSettingsRouteRouteChildren: InternalSystemSettingsRouteRouteChildren =
  {
    InternalSystemSettingsAdvisorRoute: InternalSystemSettingsAdvisorRoute,
    InternalSystemSettingsAiRoute: InternalSystemSettingsAiRoute,
    InternalSystemSettingsCleanupRoute: InternalSystemSettingsCleanupRoute,
    InternalSystemSettingsEmailRoute: InternalSystemSettingsEmailRoute,
    InternalSystemSettingsHubspotRoute: InternalSystemSettingsHubspotRoute,
    InternalSystemSettingsImagesRoute: InternalSystemSettingsImagesRoute,
    InternalSystemSettingsIndexRoute: InternalSystemSettingsIndexRoute,
  }

const InternalSystemSettingsRouteRouteWithChildren =
  InternalSystemSettingsRouteRoute._addFileChildren(
    InternalSystemSettingsRouteRouteChildren,
  )

interface InternalSystemAdministrationClassificationsRouteRouteChildren {
  InternalSystemAdministrationClassificationsCategoriesRoute: typeof InternalSystemAdministrationClassificationsCategoriesRoute
  InternalSystemAdministrationClassificationsDesignLinesRoute: typeof InternalSystemAdministrationClassificationsDesignLinesRoute
  InternalSystemAdministrationClassificationsGroupsRoute: typeof InternalSystemAdministrationClassificationsGroupsRoute
  InternalSystemAdministrationClassificationsStandardsRoute: typeof InternalSystemAdministrationClassificationsStandardsRoute
  InternalSystemAdministrationClassificationsIndexRoute: typeof InternalSystemAdministrationClassificationsIndexRoute
}

const InternalSystemAdministrationClassificationsRouteRouteChildren: InternalSystemAdministrationClassificationsRouteRouteChildren =
  {
    InternalSystemAdministrationClassificationsCategoriesRoute:
      InternalSystemAdministrationClassificationsCategoriesRoute,
    InternalSystemAdministrationClassificationsDesignLinesRoute:
      InternalSystemAdministrationClassificationsDesignLinesRoute,
    InternalSystemAdministrationClassificationsGroupsRoute:
      InternalSystemAdministrationClassificationsGroupsRoute,
    InternalSystemAdministrationClassificationsStandardsRoute:
      InternalSystemAdministrationClassificationsStandardsRoute,
    InternalSystemAdministrationClassificationsIndexRoute:
      InternalSystemAdministrationClassificationsIndexRoute,
  }

const InternalSystemAdministrationClassificationsRouteRouteWithChildren =
  InternalSystemAdministrationClassificationsRouteRoute._addFileChildren(
    InternalSystemAdministrationClassificationsRouteRouteChildren,
  )

interface InternalSystemOperationsEmailRouteRouteChildren {
  InternalSystemOperationsEmailSubscriptionsRoute: typeof InternalSystemOperationsEmailSubscriptionsRoute
  InternalSystemOperationsEmailIndexRoute: typeof InternalSystemOperationsEmailIndexRoute
}

const InternalSystemOperationsEmailRouteRouteChildren: InternalSystemOperationsEmailRouteRouteChildren =
  {
    InternalSystemOperationsEmailSubscriptionsRoute:
      InternalSystemOperationsEmailSubscriptionsRoute,
    InternalSystemOperationsEmailIndexRoute:
      InternalSystemOperationsEmailIndexRoute,
  }

const InternalSystemOperationsEmailRouteRouteWithChildren =
  InternalSystemOperationsEmailRouteRoute._addFileChildren(
    InternalSystemOperationsEmailRouteRouteChildren,
  )

interface InternalSystemRouteRouteChildren {
  InternalSystemSettingsRouteRoute: typeof InternalSystemSettingsRouteRouteWithChildren
  InternalSystemConfiguratorRoute: typeof InternalSystemConfiguratorRoute
  InternalSystemIndexRoute: typeof InternalSystemIndexRoute
  InternalSystemAdministrationClassificationsRouteRoute: typeof InternalSystemAdministrationClassificationsRouteRouteWithChildren
  InternalSystemOperationsEmailRouteRoute: typeof InternalSystemOperationsEmailRouteRouteWithChildren
  InternalSystemAdministrationBankRoute: typeof InternalSystemAdministrationBankRoute
  InternalSystemAdministrationElementTypesRoute: typeof InternalSystemAdministrationElementTypesRoute
  InternalSystemAdministrationMcpRoute: typeof InternalSystemAdministrationMcpRoute
  InternalSystemAdministrationPartiesRoute: typeof InternalSystemAdministrationPartiesRoute
  InternalSystemAdministrationPaymentPlansRoute: typeof InternalSystemAdministrationPaymentPlansRoute
  InternalSystemAdministrationProductPropertiesRoute: typeof InternalSystemAdministrationProductPropertiesRoute
  InternalSystemAdministrationUsersRoute: typeof InternalSystemAdministrationUsersRoute
  InternalSystemDevelopmentSyncRoute: typeof InternalSystemDevelopmentSyncRoute
  InternalSystemOperationsBackupRoute: typeof InternalSystemOperationsBackupRoute
  InternalSystemOperationsHistoryRoute: typeof InternalSystemOperationsHistoryRoute
  InternalSystemOperationsHousekeepingRoute: typeof InternalSystemOperationsHousekeepingRoute
  InternalSystemOperationsLogsRoute: typeof InternalSystemOperationsLogsRoute
  InternalSystemOperationsPermissionsRoute: typeof InternalSystemOperationsPermissionsRoute
  InternalSystemOperationsQueueRoute: typeof InternalSystemOperationsQueueRoute
  InternalSystemOperationsSuggestionsRoute: typeof InternalSystemOperationsSuggestionsRoute
  InternalSystemAdministrationIndexRoute: typeof InternalSystemAdministrationIndexRoute
  InternalSystemDevelopmentIndexRoute: typeof InternalSystemDevelopmentIndexRoute
  InternalSystemOperationsIndexRoute: typeof InternalSystemOperationsIndexRoute
}

const InternalSystemRouteRouteChildren: InternalSystemRouteRouteChildren = {
  InternalSystemSettingsRouteRoute:
    InternalSystemSettingsRouteRouteWithChildren,
  InternalSystemConfiguratorRoute: InternalSystemConfiguratorRoute,
  InternalSystemIndexRoute: InternalSystemIndexRoute,
  InternalSystemAdministrationClassificationsRouteRoute:
    InternalSystemAdministrationClassificationsRouteRouteWithChildren,
  InternalSystemOperationsEmailRouteRoute:
    InternalSystemOperationsEmailRouteRouteWithChildren,
  InternalSystemAdministrationBankRoute: InternalSystemAdministrationBankRoute,
  InternalSystemAdministrationElementTypesRoute:
    InternalSystemAdministrationElementTypesRoute,
  InternalSystemAdministrationMcpRoute: InternalSystemAdministrationMcpRoute,
  InternalSystemAdministrationPartiesRoute:
    InternalSystemAdministrationPartiesRoute,
  InternalSystemAdministrationPaymentPlansRoute:
    InternalSystemAdministrationPaymentPlansRoute,
  InternalSystemAdministrationProductPropertiesRoute:
    InternalSystemAdministrationProductPropertiesRoute,
  InternalSystemAdministrationUsersRoute:
    InternalSystemAdministrationUsersRoute,
  InternalSystemDevelopmentSyncRoute: InternalSystemDevelopmentSyncRoute,
  InternalSystemOperationsBackupRoute: InternalSystemOperationsBackupRoute,
  InternalSystemOperationsHistoryRoute: InternalSystemOperationsHistoryRoute,
  InternalSystemOperationsHousekeepingRoute:
    InternalSystemOperationsHousekeepingRoute,
  InternalSystemOperationsLogsRoute: InternalSystemOperationsLogsRoute,
  InternalSystemOperationsPermissionsRoute:
    InternalSystemOperationsPermissionsRoute,
  InternalSystemOperationsQueueRoute: InternalSystemOperationsQueueRoute,
  InternalSystemOperationsSuggestionsRoute:
    InternalSystemOperationsSuggestionsRoute,
  InternalSystemAdministrationIndexRoute:
    InternalSystemAdministrationIndexRoute,
  InternalSystemDevelopmentIndexRoute: InternalSystemDevelopmentIndexRoute,
  InternalSystemOperationsIndexRoute: InternalSystemOperationsIndexRoute,
}

const InternalSystemRouteRouteWithChildren =
  InternalSystemRouteRoute._addFileChildren(InternalSystemRouteRouteChildren)

interface InternalCustomerViewUserIdProjectProjectIdRouteRouteChildren {
  InternalCustomerViewUserIdProjectProjectIdConfigureRoute: typeof InternalCustomerViewUserIdProjectProjectIdConfigureRoute
  InternalCustomerViewUserIdProjectProjectIdSummaryRoute: typeof InternalCustomerViewUserIdProjectProjectIdSummaryRoute
  InternalCustomerViewUserIdProjectProjectIdIndexRoute: typeof InternalCustomerViewUserIdProjectProjectIdIndexRoute
}

const InternalCustomerViewUserIdProjectProjectIdRouteRouteChildren: InternalCustomerViewUserIdProjectProjectIdRouteRouteChildren =
  {
    InternalCustomerViewUserIdProjectProjectIdConfigureRoute:
      InternalCustomerViewUserIdProjectProjectIdConfigureRoute,
    InternalCustomerViewUserIdProjectProjectIdSummaryRoute:
      InternalCustomerViewUserIdProjectProjectIdSummaryRoute,
    InternalCustomerViewUserIdProjectProjectIdIndexRoute:
      InternalCustomerViewUserIdProjectProjectIdIndexRoute,
  }

const InternalCustomerViewUserIdProjectProjectIdRouteRouteWithChildren =
  InternalCustomerViewUserIdProjectProjectIdRouteRoute._addFileChildren(
    InternalCustomerViewUserIdProjectProjectIdRouteRouteChildren,
  )

interface InternalCustomerViewUserIdRouteRouteChildren {
  InternalCustomerViewUserIdDashboardRoute: typeof InternalCustomerViewUserIdDashboardRoute
  InternalCustomerViewUserIdMatchesRoute: typeof InternalCustomerViewUserIdMatchesRoute
  InternalCustomerViewUserIdIndexRoute: typeof InternalCustomerViewUserIdIndexRoute
  InternalCustomerViewUserIdProjectProjectIdRouteRoute: typeof InternalCustomerViewUserIdProjectProjectIdRouteRouteWithChildren
  InternalCustomerViewUserIdProjectIndexRoute: typeof InternalCustomerViewUserIdProjectIndexRoute
}

const InternalCustomerViewUserIdRouteRouteChildren: InternalCustomerViewUserIdRouteRouteChildren =
  {
    InternalCustomerViewUserIdDashboardRoute:
      InternalCustomerViewUserIdDashboardRoute,
    InternalCustomerViewUserIdMatchesRoute:
      InternalCustomerViewUserIdMatchesRoute,
    InternalCustomerViewUserIdIndexRoute: InternalCustomerViewUserIdIndexRoute,
    InternalCustomerViewUserIdProjectProjectIdRouteRoute:
      InternalCustomerViewUserIdProjectProjectIdRouteRouteWithChildren,
    InternalCustomerViewUserIdProjectIndexRoute:
      InternalCustomerViewUserIdProjectIndexRoute,
  }

const InternalCustomerViewUserIdRouteRouteWithChildren =
  InternalCustomerViewUserIdRouteRoute._addFileChildren(
    InternalCustomerViewUserIdRouteRouteChildren,
  )

interface InternalProjectsIdRouteRouteChildren {
  InternalProjectsIdDocumentsRoute: typeof InternalProjectsIdDocumentsRoute
  InternalProjectsIdFinanceRoute: typeof InternalProjectsIdFinanceRoute
  InternalProjectsIdOverviewRoute: typeof InternalProjectsIdOverviewRoute
  InternalProjectsIdPlanningRoute: typeof InternalProjectsIdPlanningRoute
  InternalProjectsIdIndexRoute: typeof InternalProjectsIdIndexRoute
}

const InternalProjectsIdRouteRouteChildren: InternalProjectsIdRouteRouteChildren =
  {
    InternalProjectsIdDocumentsRoute: InternalProjectsIdDocumentsRoute,
    InternalProjectsIdFinanceRoute: InternalProjectsIdFinanceRoute,
    InternalProjectsIdOverviewRoute: InternalProjectsIdOverviewRoute,
    InternalProjectsIdPlanningRoute: InternalProjectsIdPlanningRoute,
    InternalProjectsIdIndexRoute: InternalProjectsIdIndexRoute,
  }

const InternalProjectsIdRouteRouteWithChildren =
  InternalProjectsIdRouteRoute._addFileChildren(
    InternalProjectsIdRouteRouteChildren,
  )

interface InternalRouteRouteChildren {
  InternalSystemRouteRoute: typeof InternalSystemRouteRouteWithChildren
  InternalAccountRoute: typeof InternalAccountRoute
  InternalCatalogueRoute: typeof InternalCatalogueRoute
  InternalDashboardRoute: typeof InternalDashboardRoute
  InternalMatchingRoute: typeof InternalMatchingRoute
  InternalMediaRoute: typeof InternalMediaRoute
  InternalPropertiesRoute: typeof InternalPropertiesRoute
  InternalCustomerViewUserIdRouteRoute: typeof InternalCustomerViewUserIdRouteRouteWithChildren
  InternalProjectsIdRouteRoute: typeof InternalProjectsIdRouteRouteWithChildren
  InternalProjectsIndexRoute: typeof InternalProjectsIndexRoute
}

const InternalRouteRouteChildren: InternalRouteRouteChildren = {
  InternalSystemRouteRoute: InternalSystemRouteRouteWithChildren,
  InternalAccountRoute: InternalAccountRoute,
  InternalCatalogueRoute: InternalCatalogueRoute,
  InternalDashboardRoute: InternalDashboardRoute,
  InternalMatchingRoute: InternalMatchingRoute,
  InternalMediaRoute: InternalMediaRoute,
  InternalPropertiesRoute: InternalPropertiesRoute,
  InternalCustomerViewUserIdRouteRoute:
    InternalCustomerViewUserIdRouteRouteWithChildren,
  InternalProjectsIdRouteRoute: InternalProjectsIdRouteRouteWithChildren,
  InternalProjectsIndexRoute: InternalProjectsIndexRoute,
}

const InternalRouteRouteWithChildren = InternalRouteRoute._addFileChildren(
  InternalRouteRouteChildren,
)

interface PublicRouteRouteChildren {
  PublicConfiguratorSummaryRoute: typeof PublicConfiguratorSummaryRoute
  PublicProjectsIdRoute: typeof PublicProjectsIdRoute
  PublicUnsubscribeTokenRoute: typeof PublicUnsubscribeTokenRoute
  PublicConfiguratorIndexRoute: typeof PublicConfiguratorIndexRoute
  PublicProjectsPreviewIndexRoute: typeof PublicProjectsPreviewIndexRoute
  PublicProjectsIndexRoute: typeof PublicProjectsIndexRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicConfiguratorSummaryRoute: PublicConfiguratorSummaryRoute,
  PublicProjectsIdRoute: PublicProjectsIdRoute,
  PublicUnsubscribeTokenRoute: PublicUnsubscribeTokenRoute,
  PublicConfiguratorIndexRoute: PublicConfiguratorIndexRoute,
  PublicProjectsPreviewIndexRoute: PublicProjectsPreviewIndexRoute,
  PublicProjectsIndexRoute: PublicProjectsIndexRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CustomerRouteRoute: CustomerRouteRouteWithChildren,
  InternalRouteRoute: InternalRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  McpConsentRoute: McpConsentRoute,
  PasswordResetTokenRoute: PasswordResetTokenRoute,
  StyleguideCustomerRoute: StyleguideCustomerRoute,
  StyleguideInternalRoute: StyleguideInternalRoute,
  UploadTokenRoute: UploadTokenRoute,
  StyleguideIndexRoute: StyleguideIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
